import React from 'react';

import ParticipantProfilePreviewView from './ParticipantProfilePreviewView';
import { IUserProfilePreview } from './interfaces';

const ParticipantProfilePreview = ({
  user,
  showFollowMe,
  onFollow,
}: IUserProfilePreview) => {
  if (!user) {
    return null;
  }

  const fullUserName = user.name || '';

  return (
    <ParticipantProfilePreviewView
      user={user}
      fullUserName={fullUserName}
      showFollowMe={showFollowMe}
      onFollow={onFollow}
    />
  );
};

export default ParticipantProfilePreview;
